<script>
  import NewAdmin from "../lib/components/modals/admins/NewAdmin.svelte";
  import backend from "../server";
  import { onMount } from "svelte";
  import Pagination from "../lib/components/Pagination.svelte";
  import Loading from "../lib/components/Loading.svelte";
  import { ICONS } from "../js/icons";
  import Toast from './Toast.svelte';

  let filters = { page: 1, xpage: 20, search: "" };
  let users = { list: [] };
  let showModalNew = false;
  let loading = false;
  let selectedUser = null;
  let currentUser = null;

  let isSuperAdmin = false;
  $: isSuperAdmin = currentUser?.role === -1;

  onMount(() => {
    const userStr = sessionStorage.getItem("user");
    if (userStr) {
      try { currentUser = JSON.parse(userStr); } catch {}
    }
    list();
  });

  const list = async () => {
    try {
      let params = { ...filters };
      loading = true;
      let response = await backend.admins.list(params);
      const data = response.data;
      let list = Array.isArray(data) ? data : (data?.list || []);

      const userIds = list.map(u => u.id).filter(Boolean);
      if (userIds.length > 0) {
        try {
          const [boViewsAll, boClientsAll, amViewsAll, amClientsAll] = await Promise.all([
            backend.admins.getCredentials('bo_views.'),
            backend.admins.getCredentials('bo_clients.'),
            backend.admins.getCredentials('am_views.'),
            backend.admins.getCredentials('am_clients.'),
          ]);
          const boV = boViewsAll.data || {};
          const boC = boClientsAll.data || {};
          const amV = amViewsAll.data || {};
          const amC = amClientsAll.data || {};
          list = list.map(u => {
            const parse = raw => raw ? raw.split(',').map(s => s.trim()).filter(Boolean) : [];
            return { ...u, _boViews: parse(boV[`bo_views.${u.id}`]), _boClients: parse(boC[`bo_clients.${u.id}`]), _amViews: parse(amV[`am_views.${u.id}`]), _amClients: parse(amC[`am_clients.${u.id}`]) };
          });
        } catch (e) { console.error('Error fetching credentials', e); }
      }

      list.sort((a, b) => {
        const roleA = a.role === -1 ? 0 : 1;
        const roleB = b.role === -1 ? 0 : 1;
        if (roleA !== roleB) return roleA - roleB;
        return (a.username || '').localeCompare(b.username || '');
      });
      if (Array.isArray(data)) {
        users = { list, total: list.length, page: 1, xpage: filters.xpage };
      } else {
        users = { list, total: data?.total || list.length, page: data?.page || 1, xpage: data?.xpage || filters.xpage };
      }
      filters.page = 1;
    } catch (error) {
      console.error(error);
      users = { list: [], total: 0, page: 1, xpage: filters.xpage };
    } finally {
      loading = false;
    }
  };

  const NewAdminUser = () => {
    selectedUser = { status: 1 };
    showModalNew = true;
  };

  const confirmSave = () => {
    list();
  };

  const onDelete = async (item) => {
    if (!currentUser) return;
    if (item.role === -1) return;
    if (item.username === currentUser.username) return;
    const confirmed = window.confirm(`¿Estás seguro que quieres eliminar al usuario ${item.username}?`);
    if (!confirmed) return;
    try {
      let response = await backend.admins.remove(item.id);
      if (response.data?.status === 200) {
        filters.page = 1;
        list();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const onEdit = (item) => {
    if (item.role === -1) return;
    selectedUser = { ...item };
    showModalNew = true;
  };

  const onPageClick = (page) => {
    filters.page = page;
    list();
  };

  const searchEnter = (e) => {
    if (e.charCode === 13) list();
  };

  const toggleStatus = async (item) => {
    const newStatus = item.status === 1 ? 0 : 1;
    const action = newStatus === 1 ? 'activar' : 'desactivar';
    if (!window.confirm(`¿Estás seguro de ${action} al usuario ${item.username}?`)) return;
    try {
      await backend.admins.save({
        id: item.id,
        role: item.role,
        status: newStatus,
        address: "ADMIN_BO",
      });
      list();
    } catch (error) {
      console.error(error);
    }
  };
</script>

<Toast />
<div class="admin-container">
  <div class="card-section">
    <div class="admin-toolbar">
      <div class="admin-toolbar-left">
        <input class="form-control form-control-sm" bind:value={filters.search} placeholder="Buscar..." on:keypress={searchEnter} />
        <button class="btn btn-primary btn-sm" on:click={list}>{@html ICONS.search}</button>
        <span class="legend-sep"></span>
        <span class="badge bg-primary">BO</span>
        <span class="legend-label">Backoffice</span>
        <span class="badge bg-success">Rep</span>
        <span class="legend-label">Reportería</span>
        <span class="badge bg-warning text-dark">GB</span>
        <span class="legend-label">Gestor Bonos</span>
        <span class="pill-sm legend-client">CLI</span>
        <span class="legend-label">Clientes</span>
      </div>
      {#if isSuperAdmin}
        <button class="btn btn-primary btn-sm" on:click={NewAdminUser}>
          {@html ICONS.addCircle} Nuevo Administrador
        </button>
      {/if}
    </div>
    <div class="container-table mt-2">
      {#if loading}
        <Loading loading />
      {:else}
        <table class="table table-striped table-sm">
          <thead class="table-dark">
            <tr>
              <th>#</th>
              <th>Usuario</th>
              <th>Nombres</th>
              <th>Rol</th>
              <th>Estado</th>
              <th>Permisos</th>
              {#if isSuperAdmin}
                <th class="center"></th>
              {/if}
            </tr>
          </thead>
          <tbody>
            {#each users.list as user, index}
              <tr>
                <td>{index + 1 + (filters.page - 1) * filters.xpage}</td>
                <td>{user.username}</td>
                <td>{user.firstname}</td>
                <td>
                  {#if user.role === -1}
                    <span class="badge bg-danger">SUPER ADMIN</span>
                  {:else}
                    <span class="badge bg-primary">ADMIN</span>
                  {/if}
                </td>
                <td>
                  <span class="status-pill" class:active={user.status === 1} on:click={() => isSuperAdmin && user.role !== -1 && toggleStatus(user)} title={isSuperAdmin && user.role !== -1 ? (user.status === 1 ? 'Desactivar' : 'Activar') : ''}>
                    {user.status === 1 ? 'Activo' : 'Inactivo'}
                  </span>
                </td>
                <td class="perm-cell">
                  {#if user._boViews && user._boViews.length > 0}
                    <div class="perm-section">
                      {#if user._boViews.some(v => ['users_lite','transactions_lite'].includes(v))}
                        <span class="badge bg-success me-1">Rep</span>
                        {#each user._boViews as v}
                          <span class="pill-sm">{v}</span>
                        {/each}
                      {:else}
                        <span class="badge bg-primary me-1">BO</span>
                        {#each user._boViews as v}
                          <span class="pill-sm">{v}</span>
                        {/each}
                      {/if}
                    </div>
                    {#if user._boClients && user._boClients.length > 0}
                      <div class="perm-section">
                        {#each user._boClients as c}
                          <span class="pill-sm pill-client">{c}</span>
                        {/each}
                      </div>
                    {/if}
                  {/if}
                  {#if (user._amViews && user._amViews.length > 0) || (user._amClients && user._amClients.length > 0)}
                    <div class="perm-section">
                      <span class="badge bg-warning text-dark me-1">GB</span>
                      {#each user._amViews as v}
                        <span class="pill-sm">{v}</span>
                      {/each}
                    </div>
                    {#if user._amClients && user._amClients.length > 0}
                      <div class="perm-section">
                        {#each user._amClients as c}
                          <span class="pill-sm pill-client">{c}</span>
                        {/each}
                      </div>
                    {/if}
                  {/if}
                  {#if user.role === -1}
                    <span class="fw-bold text-danger small">PERMISOS TOTALES</span>
                  {:else if (!user._boViews || user._boViews.length === 0) && (!user._amViews || user._amViews.length === 0)}
                    <span class="text-muted small">—</span>
                  {/if}
                </td>
                {#if isSuperAdmin}
                  <td class="center">
                    <div class="action-btns">
                      <button class="btn btn-info btn-sm" on:click={() => onEdit(user)} title="Editar" disabled={user.role === -1}>{@html ICONS.edit}</button>
                      <button class="btn btn-danger btn-sm" on:click={() => onDelete(user)} title="Eliminar" disabled={user.role === -1 || user.username === currentUser?.username}>{@html ICONS.delete}</button>
                    </div>
                  </td>
                {/if}
              </tr>
            {:else}
              <tr><td colspan="{isSuperAdmin ? 7 : 6}" class="text-center">No hay administradores registrados</td></tr>
            {/each}
          </tbody>
          <tfoot>
            <tr>
              <td colspan="{isSuperAdmin ? 7 : 6}">
                {#if users.list?.length}
                  <Pagination
                    bind:total={users.total}
                    bind:xpage={users.xpage}
                    bind:current={users.page}
                    {onPageClick}
                  />
                {/if}
              </td>
            </tr>
          </tfoot>
        </table>
      {/if}
    </div>
  </div>
</div>

{#if showModalNew}
  <NewAdmin {list} bind:user={selectedUser} bind:showModalNew {confirmSave} />
{/if}

<style>
  .admin-container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 1.5rem;
  }
  .card-section {
    background: #fff;
    border: 1px solid #e9ecef;
    border-radius: 0.5rem;
    padding: 1rem 1.25rem 1.25rem;
    box-shadow: 0 1px 4px rgba(0,0,0,0.04);
  }
  .admin-toolbar {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  .admin-toolbar-left {
    display: flex;
    align-items: center;
    gap: 0.3rem;
    flex-wrap: nowrap;
  }
  .admin-toolbar-left input {
    height: 31px;
    width: 220px;
  }
  .admin-toolbar .btn {
    height: 31px;
    white-space: nowrap;
  }
  .admin-toolbar .btn:last-child {
    margin-left: auto;
  }
  :global(.table tbody tr) {
    transition: box-shadow 0.2s ease;
  }
  :global(.table tbody tr:hover) {
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.08);
    background-color: rgba(255, 0, 144, 0.04);
  }
  .center { text-align: center; }
  .action-btns {
    display: flex;
    gap: 0.3rem;
    justify-content: center;
    flex-wrap: nowrap;
  }
  .status-pill {
    display: inline-block;
    padding: 0.15rem 0.6rem;
    border-radius: 1rem;
    font-size: 0.75rem;
    font-weight: 600;
    cursor: default;
    user-select: none;
    transition: all 0.15s ease;
  }
  .status-pill.active {
    background: #d1fae5;
    color: #065f46;
    border: 1px solid #a7f3d0;
  }
  .status-pill:not(.active) {
    background: #fee2e2;
    color: #991b1b;
    border: 1px solid #fecaca;
  }
  .status-pill:hover {
    opacity: 0.8;
  }
  .perm-cell {
    max-width: 320px;
  }
  .perm-section {
    display: flex;
    flex-wrap: wrap;
    gap: 0.15rem;
    align-items: center;
    margin-bottom: 0.15rem;
  }
  .pill-sm {
    display: inline-block;
    padding: 0.05rem 0.35rem;
    border-radius: 0.2rem;
    font-size: 0.7rem;
    font-weight: 500;
    background: #e9ecef;
    color: #495057;
    border: 1px solid #dee2e6;
    white-space: nowrap;
  }
  .pill-sm.pill-client {
    background: #e8f4fd;
    color: #0d6efd;
    border-color: #b8daff;
  }
  .legend-sep {
    width: 1px;
    height: 18px;
    background: #ced4da;
    margin: 0 0.3rem;
  }
  .filters .badge,
  .filters .pill-sm {
    font-size: 0.65rem;
    padding: 0.1rem 0.3rem;
  }
  .legend-label {
    font-size: 0.7rem;
    color: #6c757d;
    margin-right: 0.3rem;
  }
  .legend-client {
    background: #e8f4fd !important;
    color: #0d6efd !important;
    border-color: #b8daff !important;
  }
</style>
